

// 判断输入是否为合法的手机号码
export const isphoneNumber = (inputString) => {
    var partten = /^1[3-9]\d{9}$/
    if (partten.test(inputString)) {
        return true
    } else {
        return false
    }
}

// 手机号码中间四位为*
export const phoneReplace = (phone) => {
    var tel = "" + phone;
    var reg=/(\d{3})\d{4}(\d{4})/;
    var phoneNum = tel.replace(reg, "$1****$2")
    return phoneNum
}

// 判断是否是两位小数
export const checktwoPoint = (inputNumber) => {
    var partten = /^\d+(\.\d{1,2})?$/
    if (partten.test(inputNumber)) {
        return true
    } else {
        return false
    }
}

//制保留2位小数，如：2，会在2后面补上00.即2.00
export const toDecimal2 = (x) => {
    var f = parseFloat(x);
    if (isNaN(f)) {
        return false;
    }
    var f = Math.round(x * 100) / 100;
    var s = f.toString();
    var rs = s.indexOf('.');
    if (rs < 0) {
        rs = s.length;
        s += '.';
    }
    while (s.length <= rs + 2) {
        s += '0';
    }
    return s;
}
// 元转化为分param
export const fen = (yuan) => {
    return parseFloat(yuan) * 1000 * 100 / 1000;
};
// 分转化元展示
export const yuan = (fen) => {
    return toDecimal2(parseFloat(fen) * 1000 / 100 / 1000);
};

// 将对象转换为数组
export const  transform = (obj) =>{
    var arr = [];
    for(let item in obj){
        let goodAttr = {
            key:item,
            value:obj[item]
        };
        arr.push(goodAttr);
    }
    return arr;
}
// 判空
export const isNull = (args) => {
    if (args === null || args === 'null' || args === undefined || args === 'undefined' || args === '' || args.length === 0) {
        return true
    } else {
        return false
    }
}
// 银行卡校验
export const isBankCardNo = (bankNo) => {
    var num = /^\d*$/
    if (bankNo.length < 16 || bankNo.length > 19 || !num.test(bankNo)) {
        return false
    }
    return true
}
// 身份证验证
export const ispCardNo = (cardNo) => {
    // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
    var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    if (reg.test(cardNo) === false) {
        return false
    }
    return true
}
// 检查图片是否为全路径
export const changeImgUrl = (newUrl) => {
    if (isNull(newUrl)){
        return ""
    }
    let isChange = newUrl.indexOf("http");

    let urlImage = "https://img.gxcards.com"
    if(newUrl.indexOf("http://img.gxcards.com") > -1){
        return urlImage + newUrl.split("http://img.gxcards.com")[1]
    }
    let urlPrefix = "https://gxweb.oss-cn-beijing.aliyuncs.com/";
    if (isChange > -1) {
        return newUrl;
    } else if (isChange < 0) {
        return urlPrefix + newUrl;
    }
};


// 检查京东图片是否为全路径
export const JDchangeImgUrlN2 = (newUrl) => {
    return JDchangeImgUrl(newUrl,"n2")
};
export const JDchangeImgUrl = (newUrl,num) => {
    if (isNull(newUrl)){
        return ""
    }
    let isChange = newUrl.indexOf("http");
    let urlPrefix = "http://img13.360buyimg.com/"+num+'/';
    if (isChange > -1) {
        return newUrl;
    } else if (isChange < 0) {
        return urlPrefix + newUrl;
    }
};

export const spliceImage = (str , separator) =>{
    if (str == undefined || str.length <1){
        return []
    }
    if (str.indexOf(separator) == -1){
        return [str]
    }
    let arr = str.split(separator)
    let lastItem =  arr[arr.length - 1]
    if (typeof lastItem == 'string' && lastItem.length <1){
        arr.splice(arr.length-1 , 1)
    }
    return arr
};


//时间戳转化为时间
export const formatTime = (date) =>{
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()

    var hour = date.getHours()
    var minute = date.getMinutes()
    var second = date.getSeconds()

    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
};

//时间戳转化为时间
export const formatTimeTripList = (date) =>{
    let mDate = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();

    var hour = date.getHours();
    var minute = date.getMinutes();
    var second = date.getSeconds();

    let time;
    if(year < mDate.getFullYear()){
        time = [year,month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':');
    }else {
        time = [month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':');
    }
    return time;
};


export const formatNumber = (n) => {
    n = n.toString();
    return n[1] ? n : '0' + n
};

export function date_format(micro_second) {
    // 秒数
    var second = Math.floor(micro_second / 1000);
    //天位
    var dy = Math.floor(second / (60 * 60 * 24));
    // 小时位
    var hr = formatNumber(Math.floor(second / (60 * 60)) - (dy * 24));
    // 分钟位
    var min = formatNumber(Math.floor(second / 60) - (dy * 24 * 60) - (hr * 60));
    // 秒位
    var sec = formatNumber(Math.floor(second) - (dy * 24 * 60 * 60) - (hr * 60 * 60) - (min * 60));// equal to => var sec = second % 60;
    // 毫秒位，保留2位
    var micro_sec = formatNumber(Math.floor((micro_second % 1000) / 10));
    var all = {
        "dy": dy,
        "hr": hr,
        "min": min,
        "sec": sec,
        "msec": micro_sec
    }
    return all;
}

// 返回字段json
export const JsonParse = (data) => {
    try {
        var appDocument = document.getElementById('app')
        var appParent = appDocument.parentNode.childNodes
        for (var ele of appParent) {
            if (ele.nodeName === 'DIV' && ele.id !== 'app') {
                ele.style.display = 'none'
            }
        }
    } catch (err) {
        console.log(err)
    }
    try {
        return JSON.parse(data)
    } catch (e) {
        try {
            return JSON.parse(data.toString())
        } catch (ex) {
            return JSON.parse(JSON.stringify(data))
        }
    }
}
//手机号格式
export const konggeString =(data) => {
    var kongge_phone = data.replace(/\s*/g, "");
    var result = [];
    for (var i = 0; i < kongge_phone.length; i++) {

        if (i == 3 || i == 7) {
            result.push(" " + kongge_phone.charAt(i));
        }
        else {
            result.push(kongge_phone.charAt(i));
        }
    }
    kongge_phone = result.join("");
    return kongge_phone
}
//校验qq号
export const isQQ= (qq) => {
    qq = qq + "";
    var reg = /^[1-9]\d{4,9}$/;
    if (reg.test(qq)) {
        if (qq <= 3750000000 && qq >= 10000) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

/// 获取两个数组相同的元素
export function getArrEqual(arr1, arr2) {
    let newArr = [];
    for (let i = 0; i < arr2.length; i++) {
        for (let j = 0; j < arr1.length; j++) {
            if(arr1[j] === arr2[i]){
                newArr.push(arr1[j]);
            }
        }
    }
    return newArr;
}


/// 深copy
export const mutableCopy = function(source) {
    var result;
    if (source instanceof Object){
        result = {}
    }
    if (source instanceof Array){
        result = []
    }
    for (var key in source) {
        result[key] = typeof source[key] === 'object' ? mutableCopy(source[key]) : source[key];
    }
    return result;
}

//数组去重
export function uniq(array) {
    var temp = []; //一个新的临时数组
    for (var i = 0; i < array.length; i++) {
        if (temp.indexOf(array[i]) == -1) {
            temp.push(array[i]);
        }
    }
    return temp;
}

// 求幂积
export function powerset(arr) {
    var ps = [[]];
    for (var i=0; i < arr.length; i++) {
        for (var j = 0, len = ps.length; j < len; j++) {
            ps.push(ps[j].concat(arr[i]));
        }
    }
    return ps;
}

export function trimSpliter(str, spliter) {
    // ⊙abc⊙ => abc
    // ⊙a⊙⊙b⊙c⊙ => a⊙b⊙c
    var reLeft        = new RegExp('^' + spliter + '+', 'g');

    var reRight       = new RegExp(spliter + '+$', 'g');
    var reSpliter = new RegExp(spliter + '+', 'g');
    return str.replace(reLeft, '')
        .replace(reRight, '')
        .replace(reSpliter, spliter)
}

//乘法
export function accMul(arg1,arg2)
{
    var m=0,s1=arg1.toString(),s2=arg2.toString();
    try{m+=s1.split(".")[1].length}catch(e){}
    try{m+=s2.split(".")[1].length}catch(e){}
    return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
}
//加法
export function accAdd(arg1,arg2){
    var r1,r2,m;
    try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
    try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
    m=Math.pow(10,Math.max(r1,r2))
    return (arg1*m+arg2*m)/m
}
//减法
export function Subtr(arg1,arg2){
    var r1,r2,m,n;
    try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
    try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
    m=Math.pow(10,Math.max(r1,r2));
    n=(r1>=r2)?r1:r2;
    return ((arg1*m-arg2*m)/m).toFixed(n);
}





// WEBPACK FOOTER //
// ./src/tools.js